<script setup lang="ts">
interface SiteSwitchComponentProps {
  name: string
}

const props = defineProps<SiteSwitchComponentProps>()
const siteHandle = useSiteHandle()
const as = computed(() => `${props.name}-${siteHandle.value}`)
</script>

<template>
  <component :is="as" />
</template>
